<div class="row dashboard-outer-container">
	<div class="col-md-3"  *ngFor="let dashboard of dashboardCount">
		<a *ngIf="dashboard.url != ''; else elseBlock" routerLink="/{{dashboard.url}}">
		<div class="content-body">
			<section class="app-ecommerce-details">
				<div class="card text-center" style="padding-left: 0 !important; border-radius: 20px !important;">
					<div class="card-body border-style" [style.background-color]="dashboard.bgcolor">
						<div class="icon-bg p-50 m-0 mb-1" [style.color]="dashboard.bgcolor">
							<div class="avatar-content">
								
								<i [data-feather]="dashboard.icon" class="font-medium-5"></i>
						
							</div>
						</div>
						<div *ngIf="dashboard.totalCost <= 0">
							<h4 class="font-weight-bolder text-white">{{dashboard.title}}</h4>
							<h3 class="mb-0 line-ellipsis text-white">{{dashboard.value}}</h3>
						</div>
						<div *ngIf="dashboard.totalCost > 0">
						<div class="row" >
							<div class="col-12">
								<h4 class="font-weight-bolder text-white">{{dashboard.title}}</h4>
							</div>
							<!-- <div class="col-6">
								<h4 class="font-weight-bolder text-white">Total Cost</h4>
							</div> -->
						</div>
						<div class="row">
							<div class="col-12">
								<h3 class="mb-0 line-ellipsis text-white">{{dashboard.value}}</h3>
							</div>
							<!-- <div class="col-6">
								<h3 class="mb-0 line-ellipsis text-white">{{dashboard.totalCost}}</h3>
							</div> -->
						</div>
					</div>
					</div>
				</div>
			</section>
		</div>
	</a>

	<ng-template #elseBlock>
		<div class="content-body">
			<section class="app-ecommerce-details">
				<div class="card text-center" style="padding-left: 0 !important; border-radius: 20px !important;">
					<div class="card-body border-style" [style.background-color]="dashboard.bgcolor">
						<div class="icon-bg p-50 m-0 mb-1" [style.color]="dashboard.bgcolor">
							<div class="avatar-content">
								
								<i [data-feather]="dashboard.icon" class="font-medium-5"></i>
						
							</div>
						</div>
						<div *ngIf="dashboard.totalCost <= 0">
							<h4 class="font-weight-bolder text-white">{{dashboard.title}}</h4>
							<h3 class="mb-0 line-ellipsis text-white">{{dashboard.value}}</h3>
						</div>
						<div *ngIf="dashboard.totalCost > 0">
						<div class="row" >
							<div class="col-12">
								<h4 class="font-weight-bolder text-white">{{dashboard.title}}</h4>
							</div>
							<!-- <div class="col-6">
								<h4 class="font-weight-bolder text-white">Total Cost</h4>
							</div> -->
						</div>
						<div class="row">
							<div class="col-12">
								<h3 class="mb-0 line-ellipsis text-white">{{dashboard.value}}</h3>
							</div>
							<!-- <div class="col-6">
								<h3 class="mb-0 line-ellipsis text-white">{{dashboard.totalCost}}</h3>
							</div> -->
						</div>
					</div>
					</div>
				</div>
			</section>
		</div>
	  </ng-template>
	</div>
</div>

<hr *ngIf="dashboardCountForHydrogen && dashboardCountForHydrogen.length > 0">
<div *ngIf="dashboardCountForHydrogen && dashboardCountForHydrogen.length > 0" class="text-center pt-1"><h3 >Under the National Green Hydrogen Mission (NGHM), a Call for Proposals for R&D Projects</h3></div>
	<div class="row dashboard-outer-container" style="margin-top: 20px!important;">
	<div class="col-md-3"  *ngFor="let dashboardHydrogen of dashboardCountForHydrogen">
		<a *ngIf="dashboardHydrogen.url != ''; else elseBlock" routerLink="/{{dashboardHydrogen.url}}">
		<div class="content-body">
			<section class="app-ecommerce-details">
				<div class="card text-center" style="padding-left: 0 !important; border-radius: 20px !important;">
					<div class="card-body border-style" [style.background-color]="dashboardHydrogen.bgcolor">
						<div class="icon-bg p-50 m-0 mb-1" [style.color]="dashboardHydrogen.bgcolor">
							<div class="avatar-content">
								<i [data-feather]="dashboardHydrogen.icon" class="font-medium-5"></i>
							</div>
						</div>
							<h4 class="font-weight-bolder text-white">{{dashboardHydrogen.title}}</h4>
							<h3 class="mb-0 line-ellipsis text-white">{{dashboardHydrogen.value}}</h3>
					</div>
				</div>
			</section>
		</div>
	</a>

	</div>
</div>

<hr *ngIf="dashboardCountForCoeProposal && dashboardCountForCoeProposal.length > 0">
<div *ngIf="dashboardCountForCoeProposal && dashboardCountForCoeProposal.length > 0" class="text-center pt-1"><h3 >Coe Application, a Call for Proposals for R&D Projects</h3></div>
	<div class="row dashboard-outer-container" style="margin-top: 20px!important;">
	<div class="col-md-3"  *ngFor="let dashboardCoe of dashboardCountForCoeProposal">
		<a *ngIf="dashboardCoe.url != ''; else elseBlock" routerLink="/{{dashboardCoe.url}}">
		<div class="content-body">
			<section class="app-ecommerce-details">
				<div class="card text-center" style="padding-left: 0 !important; border-radius: 20px !important;">
					<div class="card-body border-style" [style.background-color]="dashboardCoe.bgcolor">
						<div class="icon-bg p-50 m-0 mb-1" [style.color]="dashboardCoe.bgcolor">
							<div class="avatar-content">
								<i [data-feather]="dashboardCoe.icon" class="font-medium-5"></i>
							</div>
						</div>
							<h4 class="font-weight-bolder text-white">{{dashboardCoe.title}}</h4>
							<h3 class="mb-0 line-ellipsis text-white">{{dashboardCoe.value}}</h3>
					</div>
				</div>
			</section>
		</div>
	</a>
	</div>
</div>

<hr *ngIf="dashboardCountForEuttcProposal && dashboardCountForEuttcProposal.length > 0">
<div *ngIf="dashboardCountForEuttcProposal && dashboardCountForEuttcProposal.length > 0" class="text-center pt-1"><h3 >EU-TTC Application, a Call for Proposals for R&D Projects</h3></div>
	<div class="row dashboard-outer-container" style="margin-top: 20px!important;">
	<div class="col-md-3"  *ngFor="let dashboardEuttc of dashboardCountForEuttcProposal">
		<a *ngIf="dashboardEuttc.url != ''; else elseBlock" routerLink="/{{dashboardEuttc.url}}">
		<div class="content-body">
			<section class="app-ecommerce-details">
				<div class="card text-center" style="padding-left: 0 !important; border-radius: 20px !important;">
					<div class="card-body border-style" [style.background-color]="dashboardEuttc.bgcolor">
						<div class="icon-bg p-50 m-0 mb-1" [style.color]="dashboardEuttc.bgcolor">
							<div class="avatar-content">
								<i [data-feather]="dashboardEuttc.icon" class="font-medium-5"></i>
							</div>
						</div>
							<h4 class="font-weight-bolder text-white">{{dashboardEuttc.title}}</h4>
							<h3 class="mb-0 line-ellipsis text-white">{{dashboardEuttc.value}}</h3>
					</div>
				</div>
			</section>
		</div>
	</a>
	</div>
</div>